var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleNotch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.18164C14.6807 3.89468 15.9457 5.1183 16.7102 6.64938C17.4746 8.18046 17.6924 9.92693 17.3275 11.5989C16.9626 13.2708 16.0369 14.7677 14.704 15.841C13.3712 16.9143 11.7113 17.4996 10 17.4996C8.28871 17.4996 6.62886 16.9143 5.296 15.841C3.96314 14.7677 3.03742 13.2708 2.67251 11.5989C2.30759 9.92693 2.52543 8.18046 3.28986 6.64938C4.05429 5.1183 5.31933 3.89468 6.87501 3.18164",
    stroke: "#1A181E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleNotch);
export default __webpack_public_path__ + "static/media/circle-notch.e14c98444926b178ee512641aa51f6bc.svg";
export { ForwardRef as ReactComponent };